import React, { Component, useState } from "react";
import "./view-auction-landing.styles.scss";

// import { ReactComponent as UpcomingImage } from "../../assets/upcoming-auction.svg";
// import { ReactComponent as OpenImage } from "../../assets/open-auction.svg";
// import { ReactComponent as ArchiveImage } from "../../assets/archive.svg";
// import { ReactComponent as IntermediateImage } from "../../assets/intermediate.svg";
// import { ReactComponent as ApprovalImage } from "../../assets/approved.svg";
// import { ReactComponent as RefundImage } from "../../assets/refund.svg";

import Archives from "../archives/archives.page";
import OpenAuctionLanding from "../open-auction/index.page";
import ApproveSauda from "../approve-sauda/approve-sauda.page";
import ApproveAuction from "../auction-approval/auction-approval.page";
import UpcomingAuction from "../upcoming-auction/upcoming-auction.page";
// import IntermediateScreen from "../intermediate-screen/intermediate-screen.page";
// import ApprovalScreen from "../approval-screen/approval-screen.page";
import CreateAuctionLanding from "../create-auction-landing/create-auction-landing.page";
import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";
import { selectUserData } from "../../redux/user/user.selectors";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Dispatch } from "react";

import {
  setSaudaScreen,
  setSelectedBranch,
  setViewAuctionPage,
} from "../../redux/common/common.actions";
import {
  selectBranches,
  selectSelectedBranch,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";

import { Tabs } from "antd";

const { TabPane } = Tabs;

const ViewAuctionLanding: React.FC = (props: any) => {
  const {
    setViewAuctionPage,
    selectedKey,
    globalSocket,
    userData,
    branches,
    selectedBranch,
    setSelectedBranch,
    setSaudaScreen,
  } = props;
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  // const [selectedBranch, setSelectedBranch] = useState(branches[0]?.id);
  return (
    <div className="view-auction-landing">
      <Tabs
        // defaultActiveKey={
        //   (canUserAccess(userData, FeatureCodes.AUCTION_CHECKER) &&
        //     selectedKey === 1) ||
        //   selectedKey === null ||
        //   selectedKey === undefined
        //     ? "30"
        //     : `${sessionStorage.getItem("auctionPage")}` || "30"
        // }
        activeKey={location.pathname}
        onChange={(activeKey) => {
          sessionStorage.setItem("auctionPage", activeKey);
          setViewAuctionPage(activeKey);
          setSaudaScreen();
          history.push(activeKey);
        }}
      >
        {canUserAccess(userData, FeatureCodes.AUCTION_MAKER) && (
          <TabPane tab={"Create Auctions"} key={`${url}/create`} />
        )}
        {(canUserAccess(userData, FeatureCodes.AUCTION_CHECKER) ||
          canUserAccess(userData, FeatureCodes.AUCTION_APPROVE_VIEW)) && (
          <TabPane tab={"Approve Auctions"} key={`${url}/approve`} />
        )}
        <TabPane tab={"Upcoming Auctions"} key={`${url}/upcoming`} />
        <TabPane tab={"Active Auctions"} key={`${url}/active`} />
        {/* <TabPane
          tab={
            <span className="tabname-container">
              <ApprovalImage className="tab-img" />
              <div className="tab-name">Approve Sauda</div>
            </span>
          }
          key="34"
        >
          <ApproveSauda
            {...props}
            setBranch={setSelectedBranch}
            selectedBranch={selectedBranch}
          />
        </TabPane>
        <TabPane
          tab={
            <span className="tabname-container">
              <IntermediateImage className="tab-img" />
              <div className="tab-name">Archives</div>
            </span>
          }
          key="33"
        >
          <Archives
            {...props}
            setBranch={setSelectedBranch}
            selectedBranch={selectedBranch}
          />
        </TabPane> */}
      </Tabs>
      <Switch>
        <Route path={`${path}/create`}>
          {canUserAccess(userData, FeatureCodes.AUCTION_MAKER) ? (
            <CreateAuctionLanding {...props} />
          ) : (
            <Redirect to={`${path}/approve`} />
          )}
        </Route>
        <Route path={`${path}/approve`}>
          <ApproveAuction
            {...props}
            setBranch={setSelectedBranch}
            selectedBranch={selectedBranch}
          />
        </Route>
        <Route path={`${path}/upcoming`}>
          <UpcomingAuction
            {...props}
            setBranch={setSelectedBranch}
            selectedBranch={selectedBranch}
          />
        </Route>
        <Route path={`${path}/active`}>
          <OpenAuctionLanding
            {...props}
            setBranch={setSelectedBranch}
            selectedBranch={selectedBranch}
          />
        </Route>
        <Redirect from={path} to={`${path}/create`} />
      </Switch>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedKey: selectViewAuctionPage,
  userData: selectUserData,
  branches: selectBranches,
  selectedBranch: selectSelectedBranch,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setViewAuctionPage: (activeKey: string) =>
      dispatch(setViewAuctionPage(activeKey)),
    setSelectedBranch: (index: number) => dispatch(setSelectedBranch(index)),
    setSaudaScreen: () => dispatch(setSaudaScreen(false)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewAuctionLanding);
